export const LINK_GENERATOR_VARIANTS = {
  ASIN: "ASIN",
  BRAND: "BRAND",
  KEYWORDS: "KEYWORDS",
  CANONICAL_URLS: "CANONICAL_URLS",
  CART: "CART",
  BUY_TOGETHER: "BUY_TOGETHER",
  TARGETED_ASIN_SEARCH: "TARGETED_ASIN_SEARCH",
  CLEAN_PRODUCT_PAGE: "CLEAN_PRODUCT_PAGE",
};

export const PAGES = {
  AMAZON_SELLERS_BUNDLE: "AMAZON_SELLERS_BUNDLE",
  AMAZON_TOOLKIT: "AMAZON_TOOLKIT",
  AMZSCOUT_VS_HELIUM_10: "AMZSCOUT_VS_HELIUM_10",
  AMZSCOUT_VS_JUNGLE_SCOUT: "AMZSCOUT_VS_JUNGLE_SCOUT",
  CN: "CN",
  ES: "ES",
  FBA_FEE_CALCULATOR: "FBA_FEE_CALCULATOR",
  JP_AMAZON_SELLERS_BUNDLE: "JP_AMAZON_SELLERS_BUNDLE",
  JP_PRO: "JP_PRO",
  KEYWORD_TOOLS: "KEYWORD_TOOLS",
  KEYWORD_TRACKER: "KEYWORD_TRACKER",
  LINK_GENERATOR: "LINK_GENERATOR",
  LP_HOW_SELL: "LP_HOW_SELL",
  MAIN_PAGE: "MAIN_PAGE",
  MONTHLY_TREND_REPORT: "MONTHLY_TREND_REPORT",
  ONLINE_ARBITRAGE: "ONLINE_ARBITRAGE",
  PD: "PD",
  PERSONAL_PRODUCT_IDEAS: "PERSONAL_PRODUCT_IDEAS",
  PRO: "PRO",
  PRO_AI: "PRO_AI",
  REPORT_DEALS: "REPORT_DEALS",
  REVERSE_ASIN: "REVERSE_ASIN",
  SALES_ESTIMATOR: "SALES_ESTIMATOR",
  STOCK_STATS: "STOCK_STATS",
};

export const GLOBAL_COMPONENT = {
  WEEKLY_LIVE_DEMO: "WEEKLY_LIVE_DEMO",
};

export const PAGE_OPTIONS = {
  [PAGES.AMAZON_TOOLKIT]: {
    CLICK_FORM_OPERATION: "tryforfreeelementlpbundleoa",
    REDIRECTED_URL:
      "https://chrome.google.com/webstore/detail/amazon-dropshipping-arbit/edkgpjhfpfpgkohafpaliolcfnijnibh",
    SOFTWARE: "OA_EXT",
  },
  [PAGES.AMAZON_SELLERS_BUNDLE]: {
    CLICK_FORM_OPERATION: "waforfreeelement",
    REDIRECTED_URL: "/app/",
    SOFTWARE: "WEB",
  },
  [PAGES.PERSONAL_PRODUCT_IDEAS]: {
    CLICK_FORM_OPERATION: "lppersonalproductideas",
    REDIRECTED_URL: "/app/#/reports/customideas",
    SOFTWARE: "WEB",
  },
  [PAGES.AMZSCOUT_VS_HELIUM_10]: {
    CLICK_FORM_OPERATION: "helium10",
    REDIRECTED_URL: "/app/#/database",
    SOFTWARE: "WEB",
  },
  [PAGES.AMZSCOUT_VS_JUNGLE_SCOUT]: {
    CLICK_FORM_OPERATION: "junglescout",
    REDIRECTED_URL: "/app/#/database",
    SOFTWARE: "WEB",
  },
  [PAGES.CN]: {
    CLICK_FORM_TYPE: 25,
    INTRO_REDIRECTED_URL: {
      EN: "/app/#/course",
      CN: "/cn/wa-vpn/",
    },
    REDIRECTED_URL: `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=site_cn`,
    SOFTWARE: "WEB",
  },
  [PAGES.FBA_FEE_CALCULATOR]: {
    CLICK_FORM_TYPE: 15,
    REDIRECTED_URL:
      "https://chrome.google.com/webstore/detail/amazon-fba-calculator-fre/dkgjopcolgcafhnicdahjemapkniikeh?utm_source=site&utm_medium=amzscout&utm_campaign=fba_calc_lp",
    SOFTWARE: "CALC_EXT",
  },
  [PAGES.JP_AMAZON_SELLERS_BUNDLE]: {
    CLICK_FORM_OPERATION: "sellersbundlesubscriptionjp",
    REDIRECTED_URL: "/app/#/database",
    SOFTWARE: "WEB",
  },
  [PAGES.JP_PRO]: {
    CLICK_FORM_OPERATION: "proforfreeelementlpprojp",
    REDIRECTED_URL: `${process.env.SCOUT_EXT_PRO}`,
    SOFTWARE: "SCOUT_EXT_PRO",
  },
  [PAGES.KEYWORD_TOOLS]: {
    CLICK_FORM_TYPE: 7,
    REDIRECTED_URL: "/app/#/product-keywords",
    SOFTWARE: "WEB",
  },
  [PAGES.KEYWORD_TRACKER]: {
    CLICK_FORM_OPERATION: "keywordtrackerforfreelp",
    REDIRECTED_URL: "/app/#/keyword-tracker",
    SOFTWARE: "KW_TRACKER_EXT",
  },
  [PAGES.LINK_GENERATOR]: {
    CLICK_FORM_TYPE: 22,
    REDIRECTED_URL: `${process.env.SCOUT_EXT_PRO}?utm_source=site&utm_medium=amzscout&utm_campaign=super_url_lp`,
    SOFTWARE: "SCOUT_EXT_PRO",
  },
  [PAGES.LP_HOW_SELL]: {
    CLICK_FORM_TYPE: 18,
    REDIRECTED_URL: "/app/#/course",
    SOFTWARE: "WEB",
  },
  [PAGES.MAIN_PAGE]: {
    CLICK_FORM_TYPE: 1,
    REDIRECTED_URL: { DESKTOP: "/app/#/database", MOBILE: "/app/#/course" },
    SOFTWARE: "WEB",
  },
  [PAGES.ES]: {
    CLICK_FORM_TYPE: 1,
    REDIRECTED_URL: { DESKTOP: "/app/#/database", MOBILE: "/app/#/course" },
    SOFTWARE: "WEB",
  },
  [PAGES.MONTHLY_TREND_REPORT]: {
    CLICK_FORM_OPERATION: "getmonthlyreportcrosspromocompany",
    REDIRECTED_URL: "",
    SOFTWARE: "LANDING",
  },
  [PAGES.ONLINE_ARBITRAGE]: {
    CLICK_FORM_OPERATION: "tryforfreeelementlpoa",
    REDIRECTED_URL:
      "https://chrome.google.com/webstore/detail/amazon-dropshipping-arbit/edkgpjhfpfpgkohafpaliolcfnijnibh",
    SOFTWARE: "OA_EXT",
  },
  [PAGES.PD]: {
    CLICK_FORM_TYPE: 16,
    REDIRECTED_URL: "/app/#/database",
    CLICK_FORM_OPERATION: "proforfreeelementpdlanding",
    SOFTWARE: "WEB",
  },
  [PAGES.PRO]: {
    CLICK_FORM_TYPE: 17,
    CLICK_FORM_OPERATION: "proforfreeelementlppro",
    REDIRECTED_URL: `${process.env.SCOUT_EXT_PRO}?utm_source=site&utm_medium=amzscout&utm_campaign=pro_lp`,
    SOFTWARE: "SCOUT_EXT_PRO",
  },
  [PAGES.PRO_AI]: {
    CLICK_FORM_OPERATION: "proforfreeelementlpproai",
    REDIRECTED_URL: `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=pro_ai_lp`,
    SOFTWARE: "SCOUT_EXT_PRO_NEW",
  },
  [PAGES.REPORT_DEALS]: {
    CLICK_FORM_OPERATION: "getthesamplereportlpreportdeals",
    REDIRECTED_URL: "",
    SOFTWARE: "LANDING",
  },
  [GLOBAL_COMPONENT.WEEKLY_LIVE_DEMO]: {
    CLICK_FORM_OPERATION: "weeklylivedemo",
    REDIRECTED_URL: "",
    SOFTWARE: "LANDING",
  },
  [PAGES.REVERSE_ASIN]: {
    CLICK_FORM_TYPE: 21,
    REDIRECTED_URL: "/app/#/product-keywords",
    SOFTWARE: "WEB",
  },
  [PAGES.SALES_ESTIMATOR]: {
    CLICK_ESTIMATOR_FORM_OPERATION: "getfullaccesstosalesestimator",
    CLICK_PRO_FORM_OPERATION: "proforfreeelementcentersalesestimator",
    REDIRECTED_URL: "/app/#/reports/reports",
    SOFTWARE: "WEB",
  },
  [PAGES.STOCK_STATS]: {
    CLICK_FORM_OPERATION: "proforfreeelementlpss",
    REDIRECTED_URL:
      "https://chromewebstore.google.com/detail/amzscout-stock-stats-amaz/liobflkelkokkacdemhmgkbpefgaekkm?utm_source=site&utm_medium=amzscout&utm_campaign=stock_stats_lp",
    SOFTWARE: "WEB",
  },
};

export const PAGE_CLASS_NAMES = {
  PgA: "about",
  PgAKT: "amazon-keyword-tools",
  PgAP: "affiliate-program",
  PgASB: "amazon-sellers-bundle",
  PgH: "help",
  PgASU: "amazon-super-urls",
  PgAT: "amazon-toolkit",
  PgAVH: "amzscout-vs-helium-10",
  PgAVJS: "amzscout-vs-jungle-scout",
  PgAuth: "authorization",
  PgCI: "cn/instructions",
  PgCMain: "cn",
  PgCP: "courses-page",
  PgCPV: "cn/pro-vpn",
  PgCPr: "cn/pricing",
  PgCW: "cn/withoutvpn",
  PgCWV: "cn/wa-vpn",
  PgDMain: "de",
  PgDP: "diversity-policy",
  PgEM: "/",
  PgEP: "iframe/enterprise-paywall",
  PgESM: "es",
  PgFAQ: "faq",
  PgFFC: "fba-fee-calculator",
  PgGT: "goto",
  PgI: "instruction",
  PgIAI: "instruction-ai",
  PgIPR: "instruction-product-report",
  PgIWF: "iframe/wa-feedback",
  PgIWHPBP: "iframe/wa-hot-products-bundle-paywall",
  PgIWHPP: "iframe/wa-hot-products-paywall",
  PgIWIRP: "iframe/wa-individual-report-paywall",
  PgIWOAP: "iframe/wa-oa-addon-paywall",
  PgIWP: "iframe/wa-paywall",
  PgJASB: "jp/amazon-sellers-bundle",
  PgJP: "jp/pro",
  PgJPr: "ja/pricing",
  PgKT: "keyword-tracker",
  PgLHTSOA: "lp/how-to-sell-on-amazon",
  PgMTR: "monthly-trend-report",
  PgOA: "online-arbitrage",
  PgOI: "oa-instruction",
  PgP: "pro",
  PgPAI: "pro-ai",
  PgPD: "product-database",
  PgPEU: "pw/extension-upgrade",
  PgPP: "privacy-policy",
  PgPPI: "personal-product-ideas",
  PgPr: "pricing",
  PgR: "rate",
  PgRAL: "reverse-asin-lookup",
  PgRAPG: "random-amazon-product-generator",
  PgRD: "report-deals",
  PgRP: "review-page",
  PgRU: "request-upgrade",
  PgSE: "sales-estimator",
  PgSK: "seller-kit",
  PgSKR: "seller-kit-reselling",
  PgSS: "stock-stats",
  PgSU: "safety-using",
  PgT: "testimonials",
  PgTOU: "terms-of-use",
  PgU: "services/updater",
  PgUP: "tools/uploader",
  PgVDP: "vulnerabilities-disclosure-policy",
  PgWNA: "why-not-available",
  PgWQ: "w-questionnaire",
  TeCT: "courses-templates",
  TeCuT: "customizable-template",
  TeECT: "ext-pricing-template",
  TeEQ: "ext-questionnaire",
  TeIPAAP: "iframe/pro-analysis-ai-paywall",
  TeIPAP: "iframe/pro-ai-paywall",
  TeIWLBP: "iframe/wa-listing-builder-paywall",
  TeMT: "masterclasses-templates",
  TeUDT: "university-details-templates",
  TeULT: "university-list-templates",
  TeWT: "webinars-templates",
};
export const GLOBAL_COMPONENT_CLASS_NAMES = {
  "GC-B": "common/Brands",
  "GC-CR": "common/ChromeRating",
  "GC-CSR": "common/ChromeStoreRating",
  "GC-PAB": "common/ProAiBanner",
  "GC-PB": "common/PartnerBrand",
  "GC-Q": "common/Questionnaire",
  "GC-RN": "common/RatingNow",
  "GC-SB": "common/SurveyButton",
  "GC-SD": "common/SimpleDeals",
  "GC-TS": "common/TestimonialsSection",
  "GC-UAI": "common/UsingAI",
  "GC-V": "common/Video",
  "GC-WNB": "WebinarNativeBanner",
  "GCF-FI": "common/Forms/FormIntro",
  "GCF-FP": "common/Forms/FormPage",
  "GCL-ES": "Layout/EmptySpace",
  "GCL-F": "Layout/Footer",
  "GCL-H": "Layout/Header",
  "GCL-HC": "Layout/HeaderCn",
  "GCL-MPP": "Layout/MobileProPopup",
  "GCL-P": "Layout/Popup",
  "GCL-WLD": "Layout/WeeklyLiveDemo",
  "GCL-YT": "Layout/YouTube",
  "GP-C": "Paywalls/Customizable",
};

const PAYWALLS = {
  "pro-ent-600": "/iframe/enterprise/six-hundred-launches",
  "pro-ent-615": "/iframe/enterprise/six-hundred-fifteen-launches",
  "pro-ent-6000": "/iframe/enterprise/six-thousand-launches",
  "pro-ent-10000": "/iframe/enterprise/ten-thousand-launches",
  "pro-ent-3-devices": "/iframe/enterprise/three-devices",
  "pro-ent-10-devices": "/iframe/enterprise/ten-devices",
  "pro-ent-20-devices": "/iframe/enterprise/twenty-devices",
  "pro-ent-download": "/iframe/enterprise/download-data",
  "pro-ai-ent-600": "/iframe/pro-ai-enterprise/six-hundred-launches",
  "pro-ai-ent-615": "/iframe/pro-ai-enterprise/six-hundred-fifteen-launches",
  "pro-ai-ent-6000": "/iframe/pro-ai-enterprise/six-thousand-launches",
  "pro-ai-ent-10000": "/iframe/pro-ai-enterprise/ten-thousand-launches",
  "pro-ai-ent-3-devices": "/iframe/pro-ai-enterprise/three-devices",
  "pro-ai-ent-10-devices": "/iframe/pro-ai-enterprise/ten-devices",
  "pro-ai-ent-20-devices": "/iframe/pro-ai-enterprise/twenty-devices",
  "pro-ai-ent-download": "/iframe/pro-ai-enterprise/download-data",
  "pro-ai-ent-monthly-yearly-plan": "/iframe/pro-ai-enterprise/monthly-yearly-plan",
  "customizable": "/iframe/customizable",
  "pro-ai-paywall": "/iframe/pro-ai-paywall",
  "wa-paywall": "/iframe/wa-paywall",
  "wa-hot-products-bundle": "/iframe/wa-hot-products-bundle-paywall",
  "wa-hot-products": "/iframe/wa-hot-products-paywall",
  "wa-individual-report": "/iframe/wa-individual-report-paywall",
  "wa-listing-builder": "/iframe/wa-listing-builder-paywall",
  "wa-oa-addon": "/iframe/wa-oa-addon-paywall",
};

export const UI_DESIGN_COMPONENT_CLASS_NAMES = {
  "UI-C": "UI/Container",
};

export const COPY_RIGHT = {
  ALL_RIGHTS_RESERVED: `© AMZScout. All rights reserved 2016-${new Date().getFullYear()}`,
  ADDRESSES: {
    US:
      "AMZScout Corp., 2093 Philadelphia Pike, #3113, Claymont, Delaware, 19703, USA",
    DUBAI:
      "Growthco DMCC, Unit No: BA402, DMCC Business Centre, Level No 1, Jewellery & Gemplex 3, Dubai, UAE",
  },
};
export const TEXT_ENTER_YOUR_EMAIL = {
  cn: "请输入您的电子邮件地址",
  de: "Geben Sie Ihre E-Mail ein",
  en: "Please enter your email",
  ja: "メールアドレスを入力してください。",
  es: "Por favor, introduce tu correo electrónico",
  fr: "Veuillez saisir votre adresse e-mail",
  pt: "Digite seu e-mail",
  it: "Inserisci la tua email",
  ar: "يُرجى إدخال بريدك الإلكتروني",
  tr: "Lütfen e-posta adresinizi girin",
};
export const TEXT_ADDRESS_IS_INVALID = {
  cn: "您的电子邮件地址有误",
  de: "E-Mail ungültig",
  en: "Your email address is invalid",
  ja: "メールアドレスは無効で",
  es: "Tu dirección de correo electrónico no es válida",
  fr: "Votre adresse e-mail est invalide",
  pt: "Seu endereço de e-mail é inválido",
  it: "Il tuo indirizzo email non è valido",
  ar: "عنوان بريدك الإلكتروني غير صالح",
  tr: "E-posta adresiniz geçersiz",
};
export const TEXT_PLEASE_TRY_AGAIN = {
  cn: "出现了一些错误。请重试。",
  de: "Etw. ging schief. Bitte erneuern Sie.",
  en: "Something went wrong. Please try again.",
  ja: "エラーが発生していました。再試行してください。",
  es: "Algo salió mal. Inténtalo de nuevo.",
  fr: "Une erreur s'est produite. Veuillez réessayer.",
  pt: "Algo deu errado. Tente novamente.",
  it: "Qualcosa è andato storto. Riprova.",
  ar: "حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
  tr: "Bir hata oluştu. Lütfen tekrar deneyin.",
};
export const ANALYTICS_CATEGORY = {
  AFFILIATE_PROGRAM: "LANDING|affiliate-program",
  AMAZON_SELLERS_BUNDLE: "LANDING|amazon-sellers-bundle",
  AMAZON_TOOLKIT: "LANDING|amazon-toolkit",
  CN_HEADER: "CnHeader",
  DE: "LANDING|de",
  ES: "LANDING|es",
  FAQ: "LANDING|faq",
  MAIN_PAGE: "LANDING|Index",
  MCP: "LANDING|mcp",
  PRICING: "LANDING|Pricing",
  PRO_AI: "LANDING|pro_ai",
  WEEKLY_LIVE_DEMO: "weekly_live_demo",
  RANDOM_AMAZON_PRODUCT_GENERATOR: "LANDING|random-amazon-product-generator",
};

export const FONTS_STYLES = {
  cn: "lang_zh",
  ja: "lang_ja",
};

export const HEADING_TYPE = {
  ABSOLUTE: "ABSOLUTE",
  LOCALIZED: "LOCALIZED",
  STANDARD: "STANDARD",
};

export const POPUP_TYPES = {
  MOBILE_OA: "MOBILE_OA",
  MOBILE_PRO: "MOBILE_PRO",
  MOBILE_SS: "MOBILE_SS",
  PAYWALL: "PAYWALL",
  WEEKLY_LIVE_DEMO: "WEEKLY_LIVE_DEMO",
  YOU_TUBE: "YOU_TUBE",
};

export const ADDITIONAL_LANGUAGES_CHECKOUT = ["de", "cn", "ja"];
export const ADDITIONAL_LANGUAGES_BLOG = ["de", "es", "fr"];
